// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumbs_container__oeQ5p","breadcrumb":"Breadcrumbs_breadcrumb__XjKH5","item":"Breadcrumbs_item__3itB_"};